// Third-party imports
import $ from 'jquery';

// Local imports
import * as wv from '../../global/worldvision';

// example: http://world-vision-canada-fr-dev.myshopify.com/pages/bsb?asc=3015264&direct=Y&lange=EN&mc=4427423
export function getQueryParams(url) {
    let paramString = url.split('?')[1];
    if (!paramString) return {};
    let params = {};
    paramString = paramString.split('&');
    paramString.forEach(function(paramPart) {
        if (paramPart === '') {
            return;
        }
        let param = paramPart.split('=');
        params[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
    });
    return params;
}

// example: http://world-vision-canada-fr-dev.myshopify.com/collections/sponsorships/country:china+age:16?view=filter-endpoint
export function getShopifyParams(url) {
    let paramString = url.split('sponsorships/')[1];
    if (!paramString) return {};
    let params = {};
    paramString = paramString.split('?')[0];
    paramString = paramString.split('+');
    paramString.forEach(function(paramPart) {
        if (paramPart === '') {
            return;
        }
        let param = paramPart.split(':');
        params[decodeURIComponent(param[0])] = decodeURIComponent(param[1]);
    });
    return params;
}

// transform a JS params object into a Shopify string
export function getShopifyString(params) {
    return paramsToString(params, ':', '+');
}

export function getQueryString(params) {
    return paramsToString(params, '=', '&');
}

function paramsToString(params, assign_char, sep_char) {
    let param_string = '';
    Object.keys(params).forEach(function(key) {
        param_string += key + assign_char + params[key] + sep_char;
    });
    param_string = param_string.substring(0, param_string.length - 1);
    return param_string;
}

function saveToWindow(global, params) {
    wv.set_obj(global, 'url_params', params);
}

// It is expected that window.localStorage is passed in via the localstorage arg
function saveToStorage(localstorage, params) {
    Object.keys(params).forEach(function(p) {
        let val = params[p];
        if (val) {
            localstorage.setItem(p, val);
        }
    });
}

// window is passed in via global arg
// window.localStorage is passed in via localstorage arg
// It is expected that window.location.href is passed into the url arg
export function get_shopify_params(global, localstorage, url) {
    let queryParams = getQueryParams(url);
    let shopifyParams = getShopifyParams(url);
    let params = $.extend({}, queryParams, shopifyParams);
    saveToWindow(global, params);
    saveToStorage(localstorage, params);
}
